export const horizontalLayoutPadding = '10.75rem';
export const verticalLayoutPadding = '7rem';
export const horizontalPaddingDesktop = '5rem';
export const horizontalLayoutPaddingTablet = '2rem';
export const horizontalLayoutPaddingMobile = '2rem';
export const navbarMinHeight = '7rem'; //commonly used variable should be named: "navbarHeight", because minimal height of navBar is 5.5rem => (navbarMinHeight - 1.5rem)
export const topMessageMinHeight = '3rem';
